import {
  ADDITION,
  AVERAGE,
  MULTIPLY,
  DIVIDE,
  SUBSTRACTION,
  COUNT,
  FIND_RECORD,
  CUSTOM_CALCULATION,
  CUSTOM_JAVASCRIPT_LOGIC,
  CURRENCY_FORMAT,
  PERCENTAGE,
  math_datas,
} from './math-data';

import {
  CAPITALIZE,
  LOWER_CASE,
  UPPER_CASE,
  SLUGIFY,
  TRIM,
  TITLE_CASE,
  TRUNCATE,
  SUB_STRING,
  STRING_JOIN,
  CUSTOM_SENTENCE,
  BEAUTIFY_LIST,
  string_data,
  SPLIT_STRING,
  URL_PARAMETERS,
  MARKDOWN_TO_HTML,
  TABLE_FORMAT,
  MASKING,
} from './string-data';
import { FORMAT_DATE, DATE_DIFFERENCE, DATE_ADD, date_data } from './date-data';

const data = [...math_datas, ...string_data, ...date_data];
export {
  ADDITION,
  AVERAGE,
  MULTIPLY,
  SUBSTRACTION,
  CAPITALIZE,
  LOWER_CASE,
  UPPER_CASE,
  SLUGIFY,
  TRIM,
  TITLE_CASE,
  TRUNCATE,
  SUB_STRING,
  STRING_JOIN,
  SPLIT_STRING,
  FORMAT_DATE,
  COUNT,
  FIND_RECORD,
  DIVIDE,
  CUSTOM_CALCULATION,
  CUSTOM_SENTENCE,
  CURRENCY_FORMAT,
  CUSTOM_JAVASCRIPT_LOGIC,
  DATE_DIFFERENCE,
  DATE_ADD,
  BEAUTIFY_LIST,
  PERCENTAGE,
  URL_PARAMETERS,
  MARKDOWN_TO_HTML,
  TABLE_FORMAT,
  MASKING,
  data,
};
